import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CheckpointScoringType } from '../../checklist-enum';
import { FiChecklistHelperService } from '../../fi-checklist-helper.service';
import { FiWrapperTableAdditionalColumns } from '../../../fi-wrapper-table/fi-wrapper-table-additional-columns';
import { FiCheckpoint2HelperService } from '@fi-shared/checklist/fi-checkpoint2-helper.service';
import { MatSortDirection } from '@fi-shared/types';

@Component({
    selector: 'fi-checklist2-list-scoring',
    templateUrl: './fi-checklist2-list-scoring.component.html',
    styleUrl: './fi-checklist2-list-scoring.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-scoring' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListScoringComponent }],
    standalone: false,
})
export class FiChecklist2ListScoringComponent extends FiWrapperTableAdditionalColumns {
    constructor(
        private fiChecklist2HelperService: FiChecklistHelperService,
        private fiCheckpoint2HelperService: FiCheckpoint2HelperService,
    ) {
        super();
    }

    getScoringText(scoringType: CheckpointScoringType): string {
        return this.fiCheckpoint2HelperService.getScoringText(scoringType);
    }

    protected readonly MatSortDirection = MatSortDirection;
}
